export default __webpack_public_path__ + "static/media/151.a6679284.jpg";